export { FruitNinjaGameCoreModule } from './fruit-ninja-game-core.module';
export { FruitNinjaGameSelectorComponent } from './fruit-ninja-game-selector/fruit-ninja-game-selector.component';
export { FruitNinjaGameCoreService } from './fruit-ninja-game-core.service';
export { IFruitNinjaGame } from './fruit-ninja-game.interface';
